var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AttachFormModal',{ref:"modal",attrs:{"project":_vm.project,"title":"Upload File Attachment","submit-promise":_vm.upload,"submit-title":"Upload"}})}
var staticRenderFns = []

export { render, staticRenderFns }